import BaseService from "./BaseService";
import {ROOT, ACCOUNT} from "./_base";

class BoTestService extends BaseService {

    async checkBoTest() {
        const response = await this.getByUri(`${ROOT}/${ACCOUNT}/test`);
        return response.data;
    }

    async agreeBoTest() {
        const response = await this.postByUri(`${ROOT}/${ACCOUNT}/agree-bo-test`);
        return response.data;
    }

    async confirmBoTest(data, config) {
        const response = await this.post(`${ROOT}/${ACCOUNT}/confirm-bo-test`, data, config);
        return response.data;
    }

    async submitBoTest(data, config) {
        const response = await this.post(`${ROOT}/${ACCOUNT}/submit-bo-test`, data, config);
        return response.data;
    }
}
export default BoTestService;
